import storage from '@/services/storage.js'
import {
    createRouter,
    createWebHistory
} from 'vue-router'

import Main from "@/views/Main.vue";
import Home from "@/views/Home.vue"
import Login from "@/views/Login.vue"
import ResetPassword from '@/views/login/ResetPassword.vue';
import AttivazioneAccount from '@/views/login/AttivazioneAccount.vue';

import Profilo from "@/views/Profilo.vue"

import ElencoOrdini from '@/views/ElencoOrdini.vue'
import DettaglioOrdine from '@/views/DettaglioOrdine.vue'

import GestioneUtenti from '@/views/amministrazione/GestioneUtenti.vue';

const routes = [{
    path: "/",
    meta: {
        auth: true
    },
    component: Main,

    children: [{
        path: "/:catchAll(.*)",
        component: Home,
    },
    {
        path: "/",
        meta: {
            auth: true
        },
        component: Home,
    }, {
        path: '/ordini',
        name: 'ElencoOrdini',
        component: ElencoOrdini,
        meta: {
            title: 'Elenco Ordini'
        }
    },
    {
        path: '/ordini/:id',
        name: 'DettaglioOrdine',
        component: DettaglioOrdine,
        meta: {
            title: 'Dettaglio Ordine'
        }
    },
    {
        path: '/profilo',
        name: 'profilo',
        component: Profilo,
        meta: {
            title: 'Profilo utente'
        }
    },
    {
        path: '/gestione-utenti',
        name: 'GestioneUtenti',
        component: GestioneUtenti,
        meta: {
            title: 'Gestione utenti'
        }
    }
    ]
}, {
    path: "/login",
    name: "LoginPage",
    component: Login,
}, {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresAuth: false }
},
{
    path: '/attivazione',
    name: 'AttivazioneAccount',
    component: AttivazioneAccount,
    meta: { requiresAuth: false }
}
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})


router.beforeEach((to, from, next) => {

    if (to.path == "/@esci") storage.logout();

    // Controllo se è richiesta l'autenticazione
    if (to.path != "/login" && to.meta.auth && !storage.checkAuth()) {
        next({
            path: '/login'
        })
        return
    }
    // Controllo pagina login
    else if (to.path == "/login" && storage.checkAuth()) {

        // Se il login è stato fatto, vado alla pagina riservata
        next({
            path: '/'
        })

        return
    }

    next();

})
export default router